import { createComponent } from '@carvana/merch-components';

export const Container = createComponent('div', {
  className: 'bg-white pt-16 m:px-24 m:pt-[25px] l:px-32 l:pt-[33px]'
});

export const FiltersResultsContainer = createComponent('div', {
  className: 'grid gap-32 l:grid-cols-[minmax(296px,352px)_1fr]'
});

export const Main = createComponent('main', {
  className:
    'grid grow grid-rows-[auto_auto_1fr] gap-y-0 bg-white m:gap-y-24 l:gap-y-32'
});
